import React from 'react'

const LoadingApp = () => {
  return (
    <div className={`flex justify-center items-center bg-primary-blue h-screen w-full`}>
      <div className="flex flex-col items-center bg-primary-blue rounded-2xl" style={{ marginTop: '-10vh' }}>
        <svg width={'100'} height={'100'} viewBox="0 0 145 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M121.408 0C109.718 0 103.134 9.99898 99.194 13.9392C90.239 22.8943 88.1307 2.0699 80.5854 2.0699H72.3979H42.7182V24.1889C42.7182 29.7667 40.3797 32.9137 35.7026 32.9137C31.7444 32.9137 29.6771 30.4831 29.6771 26.3484V2.06478H0V30.3935C0 43.2556 7.82161 50 23.0273 50C34.7175 50 41.3008 40.001 45.241 36.0608C54.1961 27.1057 56.3044 47.9327 63.8497 47.9327H101.717V25.8111C101.717 20.2333 104.055 17.0863 108.732 17.0863C112.691 17.0863 114.758 19.5169 114.758 23.6516V47.9352H144.438V19.6065C144.43 6.74445 136.608 0 121.408 0Z"
            fill={'#fff'}
          />
        </svg>
      </div>
    </div>
  )
}

export default LoadingApp
